<template>
    <div class="px-2 pt-1">
      <div class="flex mb-0 pb-1">
        <div class="flex-0 flex align-items-center justify-content-center">
          <div class="px-0 py-1 flex align-items-center">
              <h1 class="flex m-0 p-0 text-3xl font-light text-600">Today</h1>
              <p class="flex p-0 m-0 text-base text-400 ml-2"> {{  getTodayDate() }} </p>
          </div>
        </div>
        <div class="flex-1 flex align-items-center justify-content-end">
          <div v-if="!dashboardDataLoading || attendanceLoadingIndicator" class="flex flex-wrap justify-content-start gap-1 mr-4">
            <strong class="uppercase text-200 ml-1 pt-1 font-normal" style="letter-spacing: 1px;">Auto-Refresh</strong>
            <Badge class="surface-100 px-3 py-0 mt-0">{{ formattedCountdown }}</Badge> 
          </div>
          <div v-if="!dashboardDataLoading || attendanceLoadingIndicator" class="flex flex-wrap justify-content-start gap-1 mr-3">
            <Badge class="bg-green-400 px-3 py-0 mt-0">{{ notlogoutAttendance.length }}</Badge> 
            <strong class="uppercase text-600 ml-1 pt-1 font-normal" style="letter-spacing: 1px;">Online</strong>
          </div>
          <div v-if="!dashboardDataLoading || attendanceLoadingIndicator" class="flex flex-wrap justify-content-start gap-1 mr-3">
            <Badge class="surface-300 px-3 py-0 mt-0">{{ todayWorked.length }}</Badge> 
            <strong class="uppercase text-600 ml-1 pt-1 font-normal" style="letter-spacing: 1px;">Worked</strong>
          </div>
          <div v-if="!isKioskUser">
            <Dropdown v-model="loginEmployee" :options="todayAllRoster" :disabled="dashboardDataLoading || attendanceLoadingIndicator || isKioskLoading"
                      showClear optionLabel="employee_name" placeholder="Upcoming Employee" class="w-full dashboard md:w-16rem mr-1">
              <template #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                      <div>{{ slotProps.value.employee_name }}</div>
                  </div>
                  <span v-else class="text-sm text-300">
                      {{ slotProps.placeholder }}
                  </span>
              </template>
              <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div :class="{'mr-1 text-sm text-500 w-5rem': slotProps.option.event_type === 'SHIFT', 
                      'mr-1 text-cyan-700 w-4rem': slotProps.option.event_type === 'COVER'} ">
                      <div class="mb-1">[{{ slotProps.option.event_type }}]</div>
                      <div v-if="slotProps.option.event_start >= currentTimeUnix" class="mr-2 text-xs uppercase text-green-500 w-4rem">Upcoming</div>
                      <div v-if="slotProps.option.event_start < currentTimeUnix" class="mr-2 text-xs uppercase text-red-500 w-4rem">No Show</div>
                    </div>
                    <div>
                      <div class="mb-1">{{ slotProps.option.employee_name }}</div>
                      <div class="text-400 text-sm font-bold" style="letter-spacing: 2px;">{{ formatTime(slotProps.option.event_start) }} to {{ formatTime(slotProps.option.event_end) }}</div>
                    </div>
                  </div>
              </template>
            </Dropdown>
          </div>
          <div v-if="!isKioskUser">
            <Button label="IN" :disabled="dashboardDataLoading || attendanceLoadingIndicator || isKioskLoading || isInButtonDisabled" @click="() => manuallyAttendanceEntry('in')" class="surface-300 hover:surface-500 mr-2" />
          </div>
          <div v-if="!isKioskUser">
            <Dropdown v-model="logoutEmployee" :options="allNotLogout" :disabled="dashboardDataLoading || attendanceLoadingIndicator || isKioskLoading"
                      showClear optionLabel="employee_name" placeholder="Logout Employee" class="w-full dashboard md:w-16rem mr-1">
              <template #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                      <div>{{ slotProps.value.employee_name }}</div>
                  </div>
                  <span v-else class="text-sm text-300">
                      {{ slotProps.placeholder }}
                  </span>
              </template>
              <template #option="slotProps">
                <div class="flex align-items-center">
                    <div :class="{'mr-1 text-sm text-500 w-5rem': slotProps.option.event_type === 'SHIFT', 
                      'mr-1 text-cyan-700 w-4rem': slotProps.option.event_type === 'COVER'} ">
                      <div class="mb-1">[{{ slotProps.option.event_type }}]</div>
                      <div v-if="slotProps.option.event_end >= currentTimeUnix" class="mr-2 text-xs uppercase text-green-500 w-4rem">Upcoming</div>
                      <div v-if="slotProps.option.event_end < currentTimeUnix" class="mr-2 text-xs uppercase text-yellow-500 w-4rem">No Logout</div>
                    </div>
                    <div>
                      <div class="mb-1">{{ slotProps.option.employee_name }}</div>
                      <div class="text-400 text-sm font-bold" style="letter-spacing: 2px;">{{ formatTime(slotProps.option.event_start) }} to {{ formatTime(slotProps.option.event_end) }}</div>
                    </div>
                  </div>
              </template>
            </Dropdown>
          </div>
          <div v-if="!isKioskUser">
            <Button label="OUT" :disabled="dashboardDataLoading || attendanceLoadingIndicator || isKioskLoading || isOutButtonDisabled" @click="() => manuallyAttendanceEntry('out')" class="surface-300 hover:surface-500 mr-2" />
          </div>
          <Button icon="pi pi-refresh" :loading="dashboardDataLoading || attendanceLoadingIndicator || isKioskLoading" :disabled="isClearingData || loadingLogout" @click="handleUpdateSuccess" class="surface-300 hover:surface-500 mr-2" />
          <Button icon="pi pi-sync" :disabled="isClearingData || loadingLogout || dashboardDataLoading || attendanceLoadingIndicator || isKioskLoading" @click="performClearData" class="surface-300 hover:surface-500 mr-2"/>
          <Button icon="pi pi-power-off" :loading="loadingLogout" :disabled="dashboardDataLoading || attendanceLoadingIndicator || isKioskLoading || isClearingData" @click="handleLogout" class="bg-red-800 hover:bg-red-700 mr-2" />
        </div>
      </div>
      <div v-if="dashboardDataLoading">
        <div class="imab-logo-animated">
          <div><span class="I">I</span><span class="M">M</span><span class="A">A</span><span class="B">B</span></div>
        </div>
      </div>
      <div v-else>
        <div class="dashboard-sections flex flex-wrap">
          <section-status 
            title="UPCOMING" 
            :records="todayRoster" 
            :sectionClass="'upcoming w-2'"
            :showCounter="true"
            @updateSuccess="handleUpdateSuccess"
            :loadingIndicator="attendanceLoadingIndicator">
          </section-status>
          <section-status 
            title="LEAVES" 
            :records="todayLeaves" 
            :sectionClass="'leaves  w-2'"
            :showCounter="false"
            @updateSuccess="handleUpdateSuccess"
            :loadingIndicator="attendanceLoadingIndicator">
          </section-status>
          <section-status 
            title="LATE" 
            :records="lateRecords" 
            :sectionClass="'late  w-2'"
            :showCounter="true"
            @updateSuccess="handleUpdateSuccess"
            :loadingIndicator="attendanceLoadingIndicator">
          </section-status>
          <section-status 
            title="EARLY" 
            :records="earlyRecords" 
            :sectionClass="'early  w-2'"
            :showCounter="true"
            @updateSuccess="handleUpdateSuccess"
            :loadingIndicator="attendanceLoadingIndicator">
          </section-status>
          <section-status 
            title="OVERTIME" 
            :records="overtimeRecords" 
            :sectionClass="'overtime  w-2'"
            :showCounter="true"
            @updateSuccess="handleUpdateSuccess"
            :loadingIndicator="attendanceLoadingIndicator">
          </section-status>
          <div class=" w-2">
            <section-status 
              title="NOTLOGOUT" 
              :records="notLogout" 
              :sectionClass="'notlogout w-full'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
            <section-status
              title="COVERS" 
              :records="coverRecords" 
              :sectionClass="'covers w-full'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
          </div>
        </div>
        <div class="yesterday border-top-3 border-50  mt-4 pt-2">
          <div class="flex mb-0">
            <div class="flex-0 flex align-items-center justify-content-center">
              <div class="px-0 py-1 flex align-items-center">
                <h1 class="flex m-0 p-0 text-3xl font-light text-600">Yesterday</h1>
                <p class="flex p-0 m-0 text-base text-400 ml-2"> {{  getYesterdayDate() }} </p>
              </div>
            </div>
            <div class="flex-1 flex align-items-center justify-content-end">
              <div v-if="!dashboardDataLoading || attendanceLoadingIndicator" class="flex flex-wrap justify-content-start gap-1 mr-3">
                <Badge class="surface-400 px-3 py-0 mt-0">{{ yesterdayAttendanceRecords.length }}</Badge> 
                <strong class="uppercase text-600 ml-1 pt-1 font-normal" style="letter-spacing: 1px;">Worked</strong>
              </div>
            </div>
          </div>
          <div class="dashboard-sections flex flex-wrap">
            <section-status 
              title="ONTIME" 
              :records="yesterdayOntimeRecords" 
              :sectionClass="'ontime w-2'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
            <section-status 
              title="LEAVES" 
              :records="yesterdayLeaves" 
              :sectionClass="'leaves w-2'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
            <section-status 
              title="LATE" 
              :records="yesterdayLateRecords" 
              :sectionClass="'late w-2'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
            <section-status 
              title="EARLY" 
              :records="yesterdayEarlyRecords" 
              :sectionClass="'early w-2'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
            <section-status 
              title="OVERTIME" 
              :records="yesterdayOvertimeRecords" 
              :sectionClass="'overtime w-2'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
            <section-status
              title="COVERS" 
              :records="yesterdayCoverRecords" 
              :sectionClass="'covers w-2'"
              :showCounter="true"
              @updateSuccess="handleUpdateSuccess"
              :loadingIndicator="attendanceLoadingIndicator">
            </section-status>
          </div>
        </div>
      </div>
    </div>
    <!-- Add ShiftKiosk component -->
    <ShiftKiosk :cardNumber="cardNumber" :manualCardNumber="manualCardNumber" :shiftName="shiftName" @clearCard="handleClearCard" @processComplete="handleProcessComplete" @error="handleError" />
  </template>
<script setup>
  import { ref, onMounted, computed, onBeforeUnmount, watch } from 'vue';
  import { useAuthStore } from '@/stores/auth';
  import { storeToRefs } from 'pinia';
  import { useRouter } from 'vue-router';
  import { useFetchUpcomingEmployees } from '@/composables/api/useFetchUpcomingEmployees';
  import { useFetchNotlogoutEmployees } from '@/composables/api/useFetchNotlogoutEmployees';
  import { useFetchUpcomingRosters } from '@/composables/api/useFetchUpcomingRosters';
  import { useLondonUnixTime } from '@/composables/useLondonTime';
  import { useTimeCalculation } from '@/composables/useTimeCalculation'
  import { useClearData } from '@/composables/useClearData';
  import SectionStatus from '@/components/SectionStatus.vue';
  import ShiftKiosk from '@/components/ShiftKiosk.vue';
  import Badge from 'primevue/badge';
  import Button from 'primevue/button';
  import Dropdown from 'primevue/dropdown';

  const router = useRouter();
  const authStore = useAuthStore();
  const { currentUser } = storeToRefs(authStore);
  const { formatTime } = useTimeCalculation()
  const { isClearingData, clearDataAndRefresh } = useClearData();

  const isKioskUser = computed(() => {
    return currentUser.value?.email === 'kiosk1@theorion.pk' || 
          currentUser.value?.email === 'kiosk2@theorion.pk';
  });

  const {
    getUnixTimeInThreeHours,
    getLondonUnixTime,
    startOfCurrentDay,
    endOfCurrentDay,
    startOfYesterday,
    endOfYesterday,
    getTodayDate,
    getYesterdayDate
  } = useLondonUnixTime();

  const currentTimeUnix = ref(0);
  const startOfCurrentDayUnix = ref(0);
  const endOfCurrentDayUnix = ref(0);
  const startOfYesterdayUnix = ref(0);
  const endOfYesterdayUnix = ref(0);

  // Logout
  const loadingLogout = ref(false);
  const handleLogout = async () => {
    loadingLogout.value = true;
    try {
      await authStore.logout();
      console.log('Logged out successfully');
      await clearDataAndRefresh();
      console.log('Cached Data Cleared successfully');
      // The router.push to '/login' is already handled in the store's logout action
    } catch (error) {
      console.error('Logout failed:', error);
      // Handle any logout errors here
    } finally {
      loadingLogout.value = false;
    }
  };

  // Clear Data
  const performClearData = async () => {
    isClearingData.value = true;
    await clearDataAndRefresh();
    console.log('Cached Data Cleared successfully');
    router.push('/');
    isClearingData.value = false;
  };

  const loginEmployee = ref(null);
  const logoutEmployee = ref(null);
  const isKioskLoading = ref(null);

  // You can also create a computed property for better readability:
  const isInButtonDisabled = computed(() => {
    return !loginEmployee.value;
  });
  const isOutButtonDisabled = computed(() => {
    return !logoutEmployee.value;
  });
    
  const attendanceLoadingIndicator = ref(false);
  const dashboardDataLoading = ref(false);

  const allUpcomingRosters = ref([]);
  const upcomingRosters = ref([]);
  const notlogoutAttendance = ref([]);
  const leaveRecords = ref([]);
  const attendanceRecords = ref([]);
  const yesterdayLeaveRecords = ref([]);
  const yesterdayAttendanceRecords = ref([]);
  
  // Add these new refs at the top of your script
  const refreshInterval = 5 * 60 * 1000; // 5 minutes in milliseconds
  const timeUntilNextRefresh = ref(refreshInterval);
  let refreshTimer;
  let countdownTimer;

  const initDashboardData = () => {
      const cachedDashboardData = sessionStorage.getItem('dashboardData');
      if (cachedDashboardData) {
          const data = JSON.parse(cachedDashboardData);
          notlogoutAttendance.value = data.notlogoutAttendance || [];
          leaveRecords.value = data.leaveRecords || [];
          attendanceRecords.value = data.attendanceRecords || [];
          yesterdayLeaveRecords.value = data.yesterdayLeaveRecords || [];
          yesterdayAttendanceRecords.value = data.yesterdayAttendanceRecords || [];
          upcomingRosters.value = data.upcomingRosters || [];
          dashboardDataLoading.value = false; 
      } else {
          dashboardDataLoading.value = true;
      }
  };
  
  // API Calls to fetch the filtered dashboard data
  const fetchDataFromServer = async () => {
      currentTimeUnix.value = getLondonUnixTime();
      startOfCurrentDayUnix.value = startOfCurrentDay();
      endOfCurrentDayUnix.value = endOfCurrentDay();
      startOfYesterdayUnix.value = startOfYesterday();
      endOfYesterdayUnix.value = endOfYesterday();

      attendanceLoadingIndicator.value = true;
  
      const {
          data: upcomingEmployeesData,
          fetchUpcomingEmployees
      } = useFetchUpcomingEmployees(startOfYesterdayUnix.value, endOfCurrentDayUnix.value);
  
      const {
          data: notlogoutEmployeesData,
          fetchNotlogoutEmployees
      } = useFetchNotlogoutEmployees();
  
      const {
          data: upcomingRostersData,
          fetchUpcomingRosters
      } = useFetchUpcomingRosters();
  
      try {
          await Promise.all([
              fetchUpcomingEmployees(),
              fetchNotlogoutEmployees(),
              fetchUpcomingRosters()
          ]);
  
          const filteredAllRosterRecords = upcomingRostersData.value;
          const filteredRosterRecords = upcomingRostersData.value.filter(roster =>
              roster.event_start > currentTimeUnix.value
          );
          const filteredLeaveRecords = upcomingRostersData.value
          .filter(leave =>
              leave.event_start < currentTimeUnix.value && leave.event_start > startOfCurrentDayUnix.value
          )
          .sort((a, b) => {
              // First, prioritize 'LEAVE' event_type
              if (a.event_type === 'LEAVE' && b.event_type !== 'LEAVE') return -1;
              if (b.event_type === 'LEAVE' && a.event_type !== 'LEAVE') return 1;
              
              // If both are 'LEAVE' or both are not 'LEAVE', sort by event_start in descending order
              return b.event_start - a.event_start;
          });
          const filteredAttendanceRecords = upcomingEmployeesData.value.filter(record =>
              record.event_start >= startOfCurrentDayUnix.value && record.event_start < endOfCurrentDayUnix.value
          );
          const filteredYesterdayLeaveRecords = upcomingRostersData.value
          .filter(leave =>
              leave.event_start >= startOfYesterdayUnix.value && leave.event_start < endOfYesterdayUnix.value
          )
          .sort((a, b) => {
              // First, prioritize 'LEAVE' event_type
              if (a.event_type === 'LEAVE' && b.event_type !== 'LEAVE') return -1;
              if (b.event_type === 'LEAVE' && a.event_type !== 'LEAVE') return 1;
              
              // If both are 'LEAVE' or both are not 'LEAVE', sort by event_start in descending order
              return b.event_start - a.event_start;
          });
          const filteredYesterdayAttendanceRecords = upcomingEmployeesData.value.filter(record =>
              record.event_start >= startOfYesterdayUnix.value && record.event_start < endOfYesterdayUnix.value
          );
  
          sessionStorage.setItem('dashboardData', JSON.stringify({
              notlogoutAttendance: notlogoutEmployeesData.value || [],
              leaveRecords: filteredLeaveRecords,
              attendanceRecords: filteredAttendanceRecords,
              yesterdayLeaveRecords: filteredYesterdayLeaveRecords,
              yesterdayAttendanceRecords: filteredYesterdayAttendanceRecords,
              upcomingRosters: filteredRosterRecords || [],
              allUpcomingRosters: filteredAllRosterRecords || []
          }));
  
          // Update reactive states
          notlogoutAttendance.value = notlogoutEmployeesData.value;
          leaveRecords.value = filteredLeaveRecords;
          attendanceRecords.value = filteredAttendanceRecords;
          yesterdayLeaveRecords.value = filteredYesterdayLeaveRecords;
          yesterdayAttendanceRecords.value = filteredYesterdayAttendanceRecords;
          upcomingRosters.value = filteredRosterRecords;
          allUpcomingRosters.value = filteredAllRosterRecords;
      } catch (error) {
          console.error("Failed to fetch data from server:", error);
      } finally {
          attendanceLoadingIndicator.value = false;
          dashboardDataLoading.value = false;
      }
  };

  // Add this new computed property
  const formattedCountdown = computed(() => {
    const minutes = Math.floor(timeUntilNextRefresh.value / 60000);
    const seconds = Math.floor((timeUntilNextRefresh.value % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  });

  // New function to handle automatic refresh
  const startAutoRefresh = () => {
    refreshTimer = setInterval(() => {
      handleUpdateSuccess();
    }, refreshInterval);

    // Start the countdown timer
    countdownTimer = setInterval(() => {
      timeUntilNextRefresh.value -= 1000;
      if (timeUntilNextRefresh.value < 0) {
        timeUntilNextRefresh.value = 0;
      }
    }, 1000);
  };

  // Get Current Time Unix
  currentTimeUnix.value = getLondonUnixTime();
  
  // TODAY Dashboard
  const todayAllRoster = computed(() => allUpcomingRosters.value?.filter(record => record.event_type === 'SHIFT' || record.event_type === 'COVER') || []);
  const todayWorked = computed(() => attendanceRecords.value?.filter(record => record.attendance_out !== null) || []);
  const todayRoster = computed(() => {
    const currentTime = getLondonUnixTime();
    const threeHoursLater = getUnixTimeInThreeHours();
    return upcomingRosters.value?.filter(record => 
      (record.event_type === 'SHIFT' || record.event_type === 'COVER') &&
      record.event_start >= currentTime &&
      record.event_start <= threeHoursLater
    ) || [];
  });
  const todayLeaves = computed(() => leaveRecords.value || []);
  const lateRecords = computed(() => 
    (attendanceRecords.value?.filter(record => 
      record.event_type !== 'COVER' && record.attendance_status_in === 'LATE'
    ) || [])
    .sort((a, b) => b.attendance_in - a.attendance_in)
  );
  const earlyRecords = computed(() => 
    (attendanceRecords.value?.filter(record => 
      record.event_type !== 'COVER' && 
      (record.attendance_status_in === 'EARLY' || record.attendance_status_out === 'EARLY')
    ) || [])
    .sort((a, b) => b.attendance_out - a.attendance_out)
  );
  const overtimeRecords = computed(() => 
    (attendanceRecords.value?.filter(record => 
      record.event_type !== 'COVER' && record.attendance_status_out === 'OVERTIME'
    ) || [])
    .sort((a, b) => b.attendance_out - a.attendance_out)
  );
  const coverRecords = computed(() => attendanceRecords.value?.filter(record => record.event_type === 'COVER') || []);
  /// Not Logout Filter
  const notLogout = computed(() => 
    (notlogoutAttendance.value?.filter(record => 
      currentTimeUnix.value > record.event_end
    ) || [])
    .sort((a, b) => b.event_end - a.event_end)
  );
  const allNotLogout = computed(() => {
  if (!notlogoutAttendance.value) return []
    return [...notlogoutAttendance.value].sort((a, b) => {
      const aIsUpcoming = a.event_end >= currentTimeUnix.value
      const bIsUpcoming = b.event_end >= currentTimeUnix.value
      if (aIsUpcoming === bIsUpcoming) {
        return aIsUpcoming ? a.event_end - b.event_end : b.event_end - a.event_end
      } else {
        return aIsUpcoming ? 1 : -1
      }
    })
  })

  // YESTERDAY Dashboard
  const yesterdayLeaves = computed(() => yesterdayLeaveRecords.value?.filter(record => record.event_type === 'LEAVE' || record.event_type === 'SHIFT') || []);
  const yesterdayOntimeRecords = computed(() => yesterdayAttendanceRecords.value?.filter(record => record.event_type !== 'COVER' && record.attendance_status_in === 'ONTIME' && (record.attendance_status_out === 'ONTIME' || record.attendance_status_out === 'OVERTIME')) || []);
  const yesterdayLateRecords = computed(() => 
    (yesterdayAttendanceRecords.value?.filter(record => 
      record.event_type !== 'COVER' && record.attendance_status_in === 'LATE'
    ) || [])
    .sort((a, b) => b.attendance_in - a.attendance_in)
  );
  const yesterdayEarlyRecords = computed(() => 
    (yesterdayAttendanceRecords.value?.filter(record => 
      record.event_type !== 'COVER' && 
      (record.attendance_status_in === 'EARLY' || record.attendance_status_out === 'EARLY')
    ) || [])
    .sort((a, b) => b.attendance_out - a.attendance_out)
  );
  const yesterdayOvertimeRecords = computed(() => 
    (yesterdayAttendanceRecords.value?.filter(record => 
      record.event_type !== 'COVER' && record.attendance_status_out === 'OVERTIME'
    ) || [])
    .sort((a, b) => b.attendance_out - a.attendance_out)
  );
  const yesterdayCoverRecords = computed(() => yesterdayAttendanceRecords.value?.filter(record => record.event_type === 'COVER') || []);

  const cardNumber = ref('');
  const shiftName = ref('');
  const manualCardNumber = ref('');
  const inputBuffer = ref('');

  const handleUpdateSuccess = () => {
    // Clear existing timers
    clearInterval(refreshTimer);
    clearInterval(countdownTimer);

    // Fetch new data
    Promise.all([
      Promise.resolve(initDashboardData()),
      Promise.resolve(fetchDataFromServer())
    ]).then(() => {
      // Reset the countdown and start new timers
      timeUntilNextRefresh.value = refreshInterval;
      startAutoRefresh();
    });
  };

  const manuallyAttendanceEntry = (type) => {
    let selectedEmployee, employeeType;
    if (type === 'in') {
      selectedEmployee = loginEmployee.value;
      employeeType = 'login';
    } else if (type === 'out') {
      selectedEmployee = logoutEmployee.value;
      employeeType = 'logout';
    }
    if (selectedEmployee && selectedEmployee.employee_badge_id && selectedEmployee.event_type) {
      const manuallyCardNumber = selectedEmployee.employee_badge_id;
      const getShiftName = selectedEmployee.event_type;
      manualCardNumber.value = manuallyCardNumber;
      shiftName.value = getShiftName;
      console.log(`Manual ${shiftName.value.toUpperCase()} ${type.toUpperCase()} entry for:`, manuallyCardNumber);
      if (type === 'in') {
        loginEmployee.value = null;
      } else {
        logoutEmployee.value = null;
      }
      isKioskLoading.value = true;
    } else {
      console.error(`No ${employeeType} employee selected or invalid shift type.`);
    }
  };

  function handleKeypress(e) {
    if (e.key !== 'Enter') {
      inputBuffer.value += e.key;
      return;
    }
    cardNumber.value = inputBuffer.value.trim();
    shiftName.value = "SHIFT";
    inputBuffer.value = '';
    console.log(`Card ${cardNumber.value} Pressed`);
  }

  function handleClearCard(processedCardNumber) {
    console.log(`Card ${processedCardNumber} removed.`);
    cardNumber.value = '';
    shiftName.value = '';
    manualCardNumber.value = '';
    loginEmployee.value = null;
    isKioskLoading.value = false;
  }
  function handleProcessComplete(processedCardNumber) {
    console.log(`Card ${processedCardNumber} processed successfully`);
    cardNumber.value = '';
    shiftName.value = '';
    manualCardNumber.value = '';
    loginEmployee.value = null;
    isKioskLoading.value = false;
    handleUpdateSuccess();
    timeUntilNextRefresh.value = refreshInterval;
  }

  function handleError(errorMessage) {
    console.error(`Error processing card: ${errorMessage}`);
    cardNumber.value = '';
    shiftName.value = '';
    manualCardNumber.value = '';
    loginEmployee.value = null;
    isKioskLoading.value = false;
  }

  // Watch for changes in manualCardNumber and clear loginEmployee
  watch(manualCardNumber, (newValue) => {
    if (newValue) {
      loginEmployee.value = null;
    }
  });

  onMounted(() => {
    document.addEventListener('keypress', handleKeypress);
    initDashboardData();
    fetchDataFromServer();
    startAutoRefresh();
  });

  onBeforeUnmount(() => {
    document.removeEventListener('keypress', handleKeypress);
    clearInterval(refreshTimer);
    clearInterval(countdownTimer);
  });

</script>
<style>
.dashboard .p-inputtext{padding: 10px !important;}
.dashboard-sections .nodata{
  color: #777;
  font-size: 14px;
}
.p-dropdown-items-wrapper{
  max-height: 644px !important;
}
</style>
  
